
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class ReceiptDetailsGrid extends Serenity.EntityGrid<PaymentDetailsRow, any> {
        protected getColumnsKey() { return 'Finance.PaymentDetails'; }
        protected getDialogType() { return PaymentDetailsDialog; }
        protected getIdProperty() { return ReceiptDetailsRow.idProperty; }
        protected getInsertPermission() { return PaymentDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return PaymentDetailsRow.localTextPrefix; }
        protected getService() { return PaymentDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}